import React,{Component,Fragment} from 'react';
import '../Home/Home.css';

import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
class FAQS extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: [],
        }
        this.getFAQs()
        window.scrollTo(0, 0)

    }
    
    getFAQs = () => {

        axios.get(`${LinkAPI}/api/businessowner/getFAQs`, {
        }).then(res => {
            this.setState({
                data: res.data,
                
            })

        }).catch(error => {
           
        })
    }

    render(){
        document.title ="kayn | الاسئله "; 
        document.getElementsByTagName("META")[1].content="كاين | الاسئله  ";
        document.documentElement.lang = 'ar';
        const itemdatatabel = this.state.data.map((x, i) => {
            return <div className="col-md-6 px-lg-5 px-3 my-3" key={i}>
            <h5>{x.title.ar}</h5>
            <p  className="text-muted  fontsize6">{x.answer.ar} </p>
        </div>
        })
        window.addEventListener('scroll', function (e) {
           if(document.getElementById('nav')){
            var nav = document.getElementById('nav');
            if (document.documentElement.scrollTop || document.body.scrollTop > window.innerHeight) {
                    nav.classList.add('colornav');
                    nav.classList.remove('colornav2');
                } else {
                    nav.classList.add('colornav2');
                    nav.classList.remove('colornav');
                }
           }
        });
        
        return(
        <div className="home pt-5">
  
  <Navbar />

          
            <section className="AppAR Questions  my-3 py-5">
                <div className="container">

                <div className="col-lg-7 mx-auto py-4 text-center ">
                    <h3 className="fontsize7  my-3">أسئلة مكررة</h3>
                    <p className="text-muted my-2 px-2" >نقوم باختيار وتخزين وحزم وشحن وجمع أموالك. يتيح لك ذلك التركيز على ما يهم حقًا: مضاعفة مبيعات التجارة الإلكترونية الخاصة بك ، وكسب المزيد من المال والاستمتاع بوقت فراغك في إنجاز أعمالك بواسطة فريق Halpyl لدينا!</p>
                </div> 
                <div className="row mx-0 py-5 ">
                    {/* <div className="col-md-6 px-lg-5 px-3  my-3">
                        <h5>Do I need to make a payment?</h5>
                        <p  className="text-muted  fontsize6"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras blandit purus nibh, ut rhoncus diam sollicitudin a. Fusce turpis velit, pretium eget metus et, fermentum fringilla purus.</p>
                    </div>
                    <div className="col-md-6 px-lg-5 px-3  my-3">
                        <h5>Is there any promo offers available?</h5>
                        <p  className="text-muted  fontsize6"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras blandit purus nibh, ut rhoncus diam sollicitudin a. Fusce turpis velit, pretium eget metus et, fermentum fringilla purus.</p>
                    </div>
                    <div className="col-md-6 px-lg-5 px-3 my-3">
                        <h5>How do I transfer my money to bank account?</h5>
                        <p  className="text-muted  fontsize6"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras blandit purus nibh, ut rhoncus diam sollicitudin a. Fusce turpis velit, pretium eget metus et, fermentum fringilla purus. In hac habitasse platea dictumst. Sed ut pellentesque turpis. </p>
                    </div>
                    <div className="col-md-6 px-lg-5 px-3  my-3">
                        <h5>Is it safe to send valuable package with you?</h5>
                        <p  className="text-muted  fontsize6"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras blandit purus nibh, ut rhoncus diam sollicitudin a. </p>
                    </div>
                    <div className="col-md-6 px-lg-5 px-3  my-3">
                        <h5>Can I send multiple packages at once?</h5>
                        <p  className="text-muted  fontsize6"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras blandit purus nibh, ut rhoncus diam sollicitudin a. Fusce turpis velit, pretium eget metus et, fermentum fringilla purus. In hac habitasse platea dictumst. Sed ut pellentesque turpis. </p>
                    </div>
                    <div className="col-md-6 px-lg-5 px-3  my-3">
                        <h5>How can I track my  orders?</h5>
                        <p  className="text-muted  fontsize6"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras blandit purus nibh, ut rhoncus diam sollicitudin a. Fusce turpis velit, pretium eget metus et, fermentum fringilla purus.</p>
                    </div> */}
                    {itemdatatabel}
                    </div>

                </div>
            </section>
          <hr/>
          <Footer/>
        </div>

        )
    }
}
export default FAQS;